(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('MailingCampaignService', MailingCampaignService);

  MailingCampaignService.$inject = ['$resource'];

  function MailingCampaignService ($resource) {
    return $resource(apiUrl + '/mailing/campaigns/:id', { id: '@id' }, {
      create: {
        method: 'POST',
        params: {},
        isArray: false
      },
      find: {
        method: 'GET',
        params: {},
        isArray: false
      },
      update: {
        method: 'PATCH',
        params: {},
        isArray: false
      },
      delete: {
        method: 'DELETE',
        params: {},
        isArray: false
      },
      runProcess: {
        url: apiUrl + '/mailing/fileprocessing',
        method: 'POST',
        params: {},
        isArray: false
      },
      listUploadedFiles: {
        url: apiUrl + '/mailing/uploadedfiles',
        method: 'GET',
        params: {}
      },
      checkMailing: {
        url: apiUrl + '/mailing/checkmailing',
        method: 'GET',
        params: {}
      },
      checkExpirationDate: {
        url: apiUrl + '/mailing/campaigns/check-expiration-date/:imported_files_id',
        method: 'GET',
        isArray: false
      },
      getCampaigns: {
        url: apiUrl + '/mailing/get-campaigns',
        method: 'GET',
        params: {},
        isArray: true
      }
    });
  }
})();
